import React from 'react';
import Paper from '@mui/material/Paper';

type PanelProps = {
  children: React.ReactNode;
  className?: string;
};

export function Panel({ children, className = 'fleet-panel' }: PanelProps) {
  return (
    <Paper className={className} component="section" elevation={0}>
      {children}
    </Paper>
  );
}
